import { render, staticRenderFns } from "./ChangePromotion.vue?vue&type=template&id=558144b2&scoped=true"
import script from "./ChangePromotion.vue?vue&type=script&lang=js"
export * from "./ChangePromotion.vue?vue&type=script&lang=js"
import style0 from "./ChangePromotion.vue?vue&type=style&index=0&id=558144b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558144b2",
  null
  
)

export default component.exports